import React from "react";

// Material Dashboard 2 PRO React TS components
import MDAvatar from "@cloudpremise/portal_core/src/themes/mui/components/MDAvatar";
import { useAuthProvider } from "@cloudpremise/portal_core";
import { useMaterialUIController } from "@cloudpremise/portal_core/src/themes/mui/context";

// @mui icons
import Icon from "@mui/material/Icon";

import Config from "./Config";
const cdnUrl = Config.getCdnUrl();

// Images
const profilePicture = cdnUrl + "/assets/images/team-3.jpg";

const menus = ({pluginUserMenus: pluginUserMenus}, includeHome = true) => {
    const [ authorized ] = useAuthProvider();
    const [controller] = useMaterialUIController();
    const { config } = controller;
    let userMenus = [];
    let deviderItem = [];
    if(authorized){
        deviderItem.push({ type: "divider", key: "divider-0" });
    }
    if(config.hideLayout){
        pluginUserMenus.map((menu) => {
            userMenus.push({
                ...menu,
                type: "menu_item",
            });
        });
    }else{
        userMenus = [
            {
                type: "collapse",
                name: "Brooklyn Alice",
                key: "brooklyn-alice",
                icon: <MDAvatar src={profilePicture} alt="Brooklyn Alice" size="sm" />,
                privacy: "private",
                collapse: [
                    ...pluginUserMenus,
                ]
            }
        ];
    }
    return [
        ...userMenus,
        ...deviderItem,
        includeHome ? {
            type: "menu_item",
            name: "Home",
            key: "home",
            icon: <Icon fontSize="medium">home</Icon>,
            route: "/home",
            privacy: "private",
        } : {},
    ];
};

export default menus;
